"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = load;
exports.loadSoundSprite = loadSoundSprite;
exports.preload = preload;
exports.preloadStart = preloadStart;
exports.startLoading = startLoading;
var _types = require("./types");
function load(file, name, metadata) {
  return {
    type: _types.LOAD,
    payload: {
      file: file,
      name: name,
      metadata: metadata
    }
  };
}
function preload(file, name, metadata, callback) {
  return {
    type: _types.PRELOAD,
    payload: {
      file: file,
      name: name,
      metadata: metadata,
      callback: callback
    }
  };
}
function preloadStart(callback) {
  return {
    type: _types.PRELOAD_START,
    payload: {
      callback: callback
    }
  };
}
function startLoading() {
  return {
    type: _types.START_LOADING
  };
}
function loadSoundSprite(sound, jsonFilePath, volume, cb) {
  return {
    type: _types.LOAD_SOUND_SPRITE,
    payload: {
      sound: sound,
      jsonFilePath: jsonFilePath,
      volume: volume,
      cb: cb
    }
  };
}
//# sourceMappingURL=actions.js.map